package core.dateformat.ui

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import core.dateformat.data.DateConfig
import core.dateformat.domain.DateFormatUseCase
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class DateTimeViewModel(
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
    private val dateFormatUseCase: DateFormatUseCase,
    val state: MutableStateFlow<DateTimeState> = MutableStateFlow(DateTimeState()),
) : ViewModel {

    fun onEvent(event: DateTimeEvent) {
        when (event) {
            is DateTimeEvent.GetInitialDateFormat -> getInitialDateFormat()
            is DateTimeEvent.ChangeDateFormat -> changeDateFormat(event)
        }
    }

    private fun getInitialDateFormat() =
        state.update {
            it.copy(
                selectedDateFormat = DateConfig.dateFormat,
            )
        }

    private fun changeDateFormat(event: DateTimeEvent.ChangeDateFormat) {
        dateFormatUseCase.changeDateFormat(event.dateFormat)
        state.update {
            it.copy(
                selectedDateFormat = event.dateFormat,
            )
        }
    }
}